import { VERIFY_USER_EMAIL } from 'actions/Types';

export default function emailVerified(state = null, action) {
  if (action.type === `${VERIFY_USER_EMAIL}_SUCCESS`) {
    return true;
  }

  if (action.type === `${VERIFY_USER_EMAIL}_FAILURE`) {
    return false;
  }

  return state;
}
